module.exports = __webpack_public_path__ + "static/knlogo-7c6abb21a535a6277824848117aaf208.svg";